<template>
    <a-modal :title="titlePrefix"
             :visible="true"
             centered
             :destroy-on-close="true"
             :mask-closable="false"
             :confirm-loading="confirmLoading"
             @ok="onSubmit"
             @cancel="onClose"
             wrap-class-name="single-spa-vue">
        <a-form ref="ruleForm" layout="vertical" :model="form" :rules="rules" @submit="onSubmit">
            <!--可编辑区域 start-->
            <div class="hidden">
                <a-form-item label="undefined" name="id">
                    <a-input v-model:value="form.id" placeholder="请输入undefined"/>
                </a-form-item>
            </div>
            <a-form-item label="敏感词" name="content">
                <a-input v-model:value="form.content" placeholder="请输入敏感词"/>
            </a-form-item>
            <a-form-item label="印证材料" name="researchDevelopmentAmountFile">
                <FileUpload v-model:value="form.researchDevelopmentAmountFile" />
            </a-form-item>

            <a-form-item label="新材料" name="upload">
                {{form.upload}}
                <a-upload
                    name="file"
                    :multiple="true"
                    action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                    @change="handleChange"
                >
                    <a-button>
                        <upload-outlined></upload-outlined>
                        Click to Upload
                    </a-button>
                </a-upload>
            </a-form-item>
            <!--可编辑区域 end-->
        </a-form>
    </a-modal>
</template>
<script>
import dataCheck from "@/utils/dataCheck";
import {formMixin} from "@/mixins";

export default {
    name: "AddOrEditModal",
    mixins: [formMixin],
    data() {
        return {
            form: {
                content: null,
                researchDevelopmentAmountFile: null,
                upload: null,
                id: null,
            },
            rules: {
                content: [
                    dataCheck.required({}),
                ],
                researchDevelopmentAmountFile: [
                    dataCheck.required({}),
                ],
                upload: [
                    dataCheck.required({}),
                ],
                id: [],
            },
            submitUrl: '#'
        }
    },
    methods: {
        handleChange(info) {
            if (info.file.status !== 'uploading') {
                console.log(info.file, info.fileList);
            }
            if (info.file.status === 'done') {
                this.$message.success(`${info.file.name} file uploaded successfully`);
                this.form.upload = info.file.name;
            } else if (info.file.status === 'error') {
                this.$message.error(`${info.file.name} file upload failed.`);
            }
        },
        onFileChange(e) {
            console.log(e, '================')
        },
        onFileBlur(e) {
            console.log(e, 'blur================')
        }
    },
}
</script>
<style scoped lang="less">
</style>
